import React, { useEffect, useState } from 'react';
import
  PropTypes
from 'prop-types';
import { IconHiddenOnMobile, MainContainer } from './notificationAlerts.styles';
import exclamation from '../../../images/exclamation-dark.svg'
import { BoldText, CloseIcon, FlexWrapper } from '../popUp/PopUp.styles';

export const NotificationAlerts = (props) => {
  const [ viewPopup, setViewPopup ] = useState('none');

  useEffect(() => {
    setViewPopup(props.display);
  }, [props.display]);

  const closePopUp = () => {
    props.setDisplay('none')
  }

return (
  <MainContainer display={props.display}>
    <FlexWrapper>
      <IconHiddenOnMobile src={exclamation} alt='exclamation'/>
      <BoldText>{props.notificationText}</BoldText>
    </FlexWrapper>
    <CloseIcon>
      <BoldText style={{fontWeight: '700',fontFamily:'RobotoBold'}} onClick={closePopUp}>
        Dismiss
      </BoldText>
    </CloseIcon>
  </MainContainer>
)
};

NotificationAlerts.propTypes = {
  display : PropTypes.string,
  setDisplay: PropTypes.func,
  notificationText: PropTypes.string
};

NotificationAlerts.defaultProps = {
  display : '',
  notificationText: '',
  setDisplay: ()=> {},
};
